var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"master-status-badge",style:(_vm.badgeStyle),attrs:{"data-testid":"master-status-badge"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }